export default __webpack_public_path__ + "static/media/HealthCampDetails.629f278f.png";